import React, { useContext, useEffect, useState } from "react";
import { PortalContext } from "../../../context/Provider";
import { useHistory } from "react-router";
import CruzIcon from "../../../assets/images/generico/CruzIcon";
import "./TurnosAgregados.css";

import CruzEtiqueta from "../../../assets/images/generico/CruzEtiqueta";
import ConsultaIcon from "../../../assets/images/generico/ConsultaIcon";

const TurnosAgregados = ({
  gruposMedico,
  onClickHandlerCancelarEtiq,
  buscadorTurnos,
}) => {
  return (
    <div
      className={`${
        buscadorTurnos
          ? "ptur-turnosAgregados-boxBuscadorTurno"
          : "ptur-turnosAgregados-box"
      } OpacityEffect`}
    >
      <div className="ptur-turnosAgregados-body">
        <span
          className={`ptur-turnosAgregados-title rb14m ${
            buscadorTurnos && "c-white"
          }`}
        >
          Turnos agregados:
        </span>
        <div className="ptur-turnosAgregados-etiquetaBox">
          {Array.isArray(gruposMedico) &&
            gruposMedico.length > 0 &&
            gruposMedico.map((item, index) => {
              return (
                <div
                  className={`ptur-turnosAgregados-etiqueta ${
                    buscadorTurnos ? "bgc-primary" : "bgc-latex30"
                  }`}
                  key={index}
                >
                  <div className="ptur-turnosAgregados-etiqueta-descripcion">
                    {item.particular ? (
                      <div className="ptur-turnosAgregados-etiqueta-particular">
                        <div className="ptur-turnosAgregados-etiqueta-particular-texto">
                          <ConsultaIcon color={"var(--color-white)"} />
                          <span className="ptur-turnosAgregados-descParticular c-white rb14b">
                            PARTICULAR:
                          </span>
                        </div>
                        <div className="ptur-turnosAgregados-etiqueta-particular-texto">
                          <span className="ptur-turnosAgregados-desc c-white rb14l">
                            {item.descripcion}
                          </span>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    {!item.particular && (
                      <>
                        <div>
                          <ConsultaIcon color={"var(--color-white)"} />
                        </div>
                        <div className="ptur-turnosAgregados-descContainer">
                          <span className="ptur-turnosAgregados-desc c-white rb14l">
                            {item.descripcion}
                          </span>
                        </div>
                      </>
                    )}
                    <button
                      onClick={() => onClickHandlerCancelarEtiq(item.id)}
                      className="ptur-turnosAgregados-cancelarBtn"
                    >
                      <CruzEtiqueta color={"var(--color-white)"} />
                    </button>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default TurnosAgregados;
